import * as React from 'react';
import { IgcRatingSymbolComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 *
 * Used when a custom icon/symbol/element needs to be passed to the igc-rating component.
 * @slot  - Default slot for projected full symbols/icons.
 * @slot empty - Default slot for projected empty symbols/icons.
 * @csspart symbol - The symbol wrapping container.
 * @csspart full - The full symbol wrapping container.
 * @csspart empty - The empty symbol wrapping container.
 * @class
 */
export const IgrRatingSymbol = /* @__PURE__ */ createComponent({
  tagName: 'igc-rating-symbol',
  displayName: 'IgrRatingSymbol',
  elementClass: Component,
  react: React,
});

export type IgrRatingSymbol = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrRatingSymbolModule = Component;
